import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { memo, useMemo } from 'react';

import { APP_SETTINGS } from '../../../app-settings';
import { useApiContext } from '../../../context/api-provider';
import { useConfig } from '../../../context/config-provider';

const FooterNavColumn = dynamic(() =>
  import('./footer-nav-column/footer-nav-column').then(module => module.FooterNavColumn)
);
const FooterNavColumnCollapsed = dynamic(() =>
  import('./footer-nav-column-collapsed/footer-nav-column-collapsed').then(module => module.FooterNavColumnCollapsed)
);

const filterMenuItems = (menu, sportsbookFrontendOrigin) => {
  if (
    (!APP_SETTINGS.MIRRORS_WITH_HIDDEN_URLS?.[sportsbookFrontendOrigin] &&
      !APP_SETTINGS.MIRRORS_WITH_REPLACED_URLS?.[sportsbookFrontendOrigin]) ||
    !menu?.length
  ) {
    return menu;
  }

  const filteredMenu = menu.reduce((acc, { label, items, key }) => {
    const newItems = items.reduce((menuItems, item) => {
      const isHideUrl = !APP_SETTINGS.MIRRORS_WITH_HIDDEN_URLS[sportsbookFrontendOrigin]?.urls?.find(url =>
        item.url.startsWith(url)
      );
      const isReplaceUrl = APP_SETTINGS.MIRRORS_WITH_REPLACED_URLS[sportsbookFrontendOrigin]?.urls[item.url];

      if (isHideUrl) {
        menuItems.push(item);
      }

      if (isReplaceUrl) {
        menuItems.push({
          ...item,
          url: APP_SETTINGS.MIRRORS_WITH_REPLACED_URLS[sportsbookFrontendOrigin].urls[item.url],
        });
      }

      return menuItems;
    }, []);

    acc.push({ label, key, items: newItems });
    return acc;
  }, []);

  return filteredMenu;
};

function FooterNavUI({ collapsible }) {
  const { footer } = useConfig();
  const { apiConfig } = useApiContext();

  const filteredMenu = useMemo(() => filterMenuItems(footer.menu, apiConfig.sportsbookFrontendOrigin), [
    footer.menu,
    apiConfig.sportsbookFrontendOrigin,
  ]);

  if (!footer?.menu?.length) return null;

  const FooterNavComponent = collapsible ? FooterNavColumnCollapsed : FooterNavColumn;

  return (
    <nav className="sb-FooterNav">
      {filteredMenu.map(({ label, items }, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <FooterNavComponent key={index} items={items} label={label} />
      ))}
    </nav>
  );
}

FooterNavUI.propTypes = {
  collapsible: PropTypes.bool,
};

FooterNavUI.defaultProps = {
  collapsible: false,
};

export const FooterNav = memo(FooterNavUI);
